import React, { Fragment } from "react";

const About = () => {
  return (
    <Fragment>
      <h1>About this App</h1>
      <p>App to search Github users</p>
      <p>Version: 1.0.0</p>
      <p>By: Murad Eminov</p>
    </Fragment>
  );
};

export default About;
